import React from 'react'
import PropTypes from 'prop-types'
import { polyglot } from '../../../index'

import userImage from '../../../resources/images/user.svg'

export default class PhotoEditor extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      btnIsActive: false,
      loading: ''
    }
    this.handlePictureChange = this.handlePictureChange.bind(this)
    this.handlePhotoSubmit = this.handlePhotoSubmit.bind(this)
  }
  handlePictureChange (e) {
    if (e.target.files && e.target.files[0]) {
      const reader = new window.FileReader()
      reader.onload = (e) => {
        this.refs.profilePicture.src = e.target.result
        this.setState({
          btnIsActive: true
        })
      }
      reader.readAsDataURL(e.target.files[0])
    }
  }

  handlePhotoSubmit (e) {
    e.preventDefault()
    this.props.handlePhotoSubmit(e.target.pic.files[0])
  }

  render () {
    return <form className={`form-horizontal ${this.state.loading}`} onSubmit={(e) => this.handlePhotoSubmit(e)}>
      <div className='form-group'>
        <div className='col-xs-12 center padding-input'>
          <img ref={'profilePicture'} className='patient-photo'
            src={this.props.patient.photo ? this.props.patient.photo : userImage} alt={polyglot.t('staticFields.commonFields.patientPhoto')} />
        </div>
        <div className='col-xs-12 center'>
          <span className='btn btn-default btn-file'>{polyglot.t('staticFields.commonFields.selectImage')}
            <input type='file' maxLength={100000} accept='image/*' name='pic' onChange={(e) => this.handlePictureChange(e)} />
          </span>
        </div>
      </div>
      <div className='modal-footer'>
        <button type='submit' disabled={!this.state.btnIsActive} className='btn btn-primary'>{polyglot.t('staticFields.commonFields.saveChanges')}</button>
      </div>
    </form>
  }
}

PhotoEditor.propTypes = {
  alertMsg: PropTypes.object,
  patientKey: PropTypes.string.isRequired,
  patient: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handlePhotoSubmit: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/common/PhotoEditor/PhotoEditor.js